import { useTranslation } from 'react-i18next';

import { ICertificateWithScoringFragment } from 'graphql/types';
import { InfoRow } from 'common/components/InfoRow';

interface IProps {
    certificate: ICertificateWithScoringFragment;
}

export const CertificateInfoRow = ({ certificate }: IProps) => {
    const [translate] = useTranslation();

    return (
        <InfoRow description={translate('certificate')}>
            {certificate.name}
        </InfoRow>
    );
};
